/*
Copyright (c) 2021.
*/

import maverickPortalhttp from '../../webService/webService';
import maverickPortalApiEndPoint from '../../../config/apiEndPoint';

const GetVideoData = () => {
  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.getVideo.url, 
        maverickPortalApiEndPoint.getVideo.methodType)
      .then(response => {
        const res = response.data;
        resolve({ res });
      });
  });
};

export { GetVideoData };
